$('.p-box__open.disabled').siblings('.p-box').hide();

window.classic = function(){
    $('.p-box__open--classic').css({opacity:1});
    $('.p-treasure__rwd--classic').addClass('disabled');
};
window.special = function(){
    $('.p-box__open--special').css({opacity:1});
    $('.p-treasure__rwd--special').addClass('disabled');
};

$(document).on('click', '.p-sec1__coupon', function(e) {
    e.preventDefault();
    promokit.coupon();
});

promokit.layer({
    el: '#layer-classic',
    buttons: '.p-treasure__dtl--classic'
});
promokit.layer({
    el: '#layer-special',
    buttons: '.p-treasure__dtl--special'
});


promokit.page({
    el: '#container',
    type: 'basic',
    game: 'aion',
    cnb: true,
    caution: {
        template: `<ol>
            <li>제재된 캐릭터는 이벤트 참여가 불가능합니다.</li>
            <li>해당 이벤트에서 획득한 모든 아이템은 거래 및 판매 대행이 가능하지 않습니다.</li>
            <li>클래식 보물 상자 쿠폰과 스페셜 보물상자 쿠폰은 각각 계정 당 1회 획득 가능합니다.</li> 
            <li>쿠폰은 발급한 본인만 사용 가능하며, 쿠폰 유효 기간은발급 일로부터 30일입니다.</li>
            <li>쿠폰 사용 후 획득한 [이벤트] 클래식 보물상자, [이벤트] 스페셜 보물상자 아이템은 2021. 6. 9.(수) 정기점검 시 삭제됩니다.<br>
            (인벤토리 및 우편함 수령 대기 물품함에 있는 모든 아이템이 삭제되며, 개봉 후 획득한 아이템은 삭제되지 않습니다.)</li>
        </ol>`
    },
    topButton: true,
    footer: {
        theme: 'white'
    },
    headerButton: {
        home: true,
        event: true,
        sns: true,
        theme: 'black'
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js